import {
  TweenMax,
  TimelineLite
} from 'gsap'
import _ from 'lodash'

export default {
  name: 'app',
  data: function () {
    return {
      comp: {},
      menu: false,
      isWork: false,
      isHome: false,
      lastScroll: 0
    }
  },
  computed: {
    english: function () {
      return this.$store.getters.english
    }
  },
  beforeMounted: function () {
    this.comp = this.$refs.view
    if (this.$route.name === 'work') {
      this.isWork = true
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
          display: 'block',
          opacity: 1
        })
        .to([this.$refs.navi, this.$refs.lang], 0, {
          opacity: 0,
          transform: 'translateX(-60px)'
        })
      tl.play()
    }

    if (window.addEventListener) {
      window.addEventListener('mousewheel', this.handleScroll, false)
      window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    } else {
      window.attachEvent('onmousewheel', this.handleScroll)
    }
  },
  mounted: function () {
    this.comp = this.$refs.view
    if (this.$route.name === 'work') {
      this.isWork = true
      var tl = new TimelineLite({
        paused: true
      })
      tl.to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
          display: 'block',
          opacity: 1
        })
        .to([this.$refs.navi, this.$refs.lang], 0, {
          opacity: 0,
          transform: 'translateX(-60px)'
        })
      tl.play()
    }

    if (window.addEventListener) {
      window.addEventListener('mousewheel', this.handleScroll, false)
      window.addEventListener('DOMMouseScroll', this.handleScroll, false)
    } else {
      window.attachEvent('onmousewheel', this.handleScroll)
    }
  },
  methods: {
    handleScroll: _.throttle(function (e) {

      if (Date.now() - this.lastScroll > 2200) {
        if (window.innerWidth > 900) {
          var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)))
          if (this.$route.name === 'home') {
            if (delta === -1) {
              this.$router.push('work')
              this.isWork = true
              var tl = new TimelineLite({
                paused: true
              })
              tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
                  opacity: 0,
                  transform: 'translateX(-60px)'
                })
                .to([this.$refs.navi, this.$refs.lang], 0, {
                  opacity: 0,
                  transform: 'translateX(-100vw)'
                })
                .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                  display: 'block',
                  opacity: 0,
                  transform: 'translateX(60px)'
                })
                .staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                  opacity: 1,
                  transform: 'translateX(0)'
                }, 0.05)
              tl.play()
            }
          } else if (this.$route.name === 'work') {
            if (delta === -1) {
              this.$router.push('about')
              this.isWork = false
              var tl = new TimelineLite({
                paused: true
              })
              tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                  opacity: 0,
                  transform: 'translateX(60px)',
                }, 0.05)
                .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                  display: 'none'
                })
                .to([this.$refs.navi, this.$refs.lang], 0.55, {
                  opacity: 0,
                  transform: 'translateX(-60px)'
                })
                .to([this.$refs.navi, this.$refs.lang], 0.5, {
                  opacity: 1,
                  transform: 'translateX(0px)'
                })
              tl.play()
            } else if (delta === 1) {
              this.$router.push('/')
              this.isWork = false
              var tl = new TimelineLite({
                paused: true
              })
              tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                  opacity: 0,
                  transform: 'translateX(60px)'
                }, 0.05)
                .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                  display: 'none'
                })
                .to([this.$refs.navi, this.$refs.lang], 0.55, {
                  opacity: 0,
                  transform: 'translateX(-60px)'
                })
                .to([this.$refs.navi, this.$refs.lang], 0.5, {
                  opacity: 1,
                  transform: 'translateX(0px)'
                })
              tl.play()
            }
          } else if (this.$route.name === 'about') {
            if (delta === 1) {
              if (document.documentElement.scrollTop === 0 && (Date.now() - this.lastScroll > 2000)) {
                this.$router.push('work')
                this.isWork = true
                var tl = new TimelineLite({
                  paused: true
                })
                tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
                    opacity: 0,
                    transform: 'translateX(-60px)'
                  })
                  .to([this.$refs.navi, this.$refs.lang], 0, {
                    opacity: 0,
                    transform: 'translateX(-100vw)'
                  })
                  .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                    display: 'block',
                    opacity: 0,
                    transform: 'translateX(60px)'
                  })
                  .staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                    opacity: 1,
                    transform: 'translateX(0)'
                  }, 0.05)
                tl.play()
              }
            }
          }
          /*else if (this.$route.name === 'pro') {
                   if (delta === 1) {
                     this.$router.push('about')
                   }
                 }*/
        }
        this.lastScroll = Date.now()
      }

    }, 1000),
    toggleEn: function () {
      this.$store.commit('selectEn')
    },
    toggleDe: function () {
      this.$store.commit('selectDe')
    },
    workMenuClicked: function () {
      if (window.innerWidth > 900) {
        this.menu = !this.menu
        var tl = new TimelineLite({
          paused: true
        })
        if (this.menu) {
          tl.to([this.$refs.workNavi], 0, {
              transform: 'translateY(-10px)',
              display: 'none'
            })
            .to([this.$refs.workNavi], 0.5, {
              display: 'block',
              opacity: 1,
              transform: 'translateY(0px)'
            })
          tl.play()
        } else {
          tl.to([this.$refs.workNavi], 0.5, {
            opacity: 0,
            transform: 'translateY(-10px)',
            display: 'none'
          })
          tl.play()
        }
      }
    },
    workLinkClicked: function () {
      if (window.innerWidth > 900) {
        this.menu = !this.menu
        var tl = new TimelineLite({
          paused: true
        })
        if (this.menu) {
          tl.to([this.$refs.workNavi], 0, {
              transform: 'translateY(-10px)',
              display: 'none'
            })
            .to([this.$refs.workNavi], 0.5, {
              display: 'block',
              opacity: 1,
              transform: 'translateY(0px)'
            })
          tl.play()
        } else {
          tl.to([this.$refs.workNavi], 0.5, {
            opacity: 0,
            transform: 'translateY(-10px)',
            display: 'none'
          })
          tl.play()
          this.menuClicked()
        }
      }
    },
    menuClicked: function () {
      if (window.innerWidth < 900) {
        this.menu = !this.menu
        var tl = new TimelineLite({
          paused: true
        })
        tl.from(this.$refs.menu, 0.1, {
            opacity: 0
          })
          .from(this.$refs.link1, 0.25, {
            opacity: 0,
            transform: 'translateY(-20px)'
          }, 0.1)
          .from(this.$refs.link2, 0.25, {
            opacity: 0,
            transform: 'translateY(-20px)'
          }, 0.125)
          .from(this.$refs.link3, 0.25, {
            opacity: 0,
            transform: 'translateY(-20px)'
          }, 0.15)
          /*.from(this.$refs.link4, 0.25, {
            opacity: 0,
            transform: 'translateY(-20px)'
          }, 0.175)*/
          .from(this.$refs.fb, 0.2, {
            opacity: 0,
            transform: 'translateX(-10px)'
          }, 0.25)
          .from(this.$refs.twitter, 0.2, {
            opacity: 0,
            transform: 'translateX(-10px)'
          }, 0.3)
          .from(this.$refs.dribbble, 0.2, {
            opacity: 0,
            transform: 'translateX(-10px)'
          }, 0.35)
          .from(this.$refs.language, 0.2, {
            opacity: 0,
            transform: 'translateX(-10px)'
          }, 0.35)
        tl.play()
      } else {
        if (this.$route.name === 'work') {
          this.isHome = false
          this.isWork = true
          var tl = new TimelineLite({
            paused: true
          })
          tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
              opacity: 0,
              transform: 'translateX(-60px)'
            })
            .to([this.$refs.navi, this.$refs.lang], 0, {
              opacity: 0,
              transform: 'translateX(-100vw)'
            })
            .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
              display: 'block',
              opacity: 0,
              transform: 'translateX(60px)'
            })
            .staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
              opacity: 1,
              transform: 'translateX(0)'
            }, 0.05)
          tl.play()
        } else if (this.isWork) {
          this.isWork = false
          var tl = new TimelineLite({
            paused: true
          })
          tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
              opacity: 0,
              transform: 'translateX(60px)'
            }, 0.05)
            .to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
              display: 'none'
            })
            .to([this.$refs.navi, this.$refs.lang], 0.55, {
              opacity: 0,
              transform: 'translateX(-60px)'
            })
            .to([this.$refs.navi, this.$refs.lang], 0.5, {
              opacity: 1,
              transform: 'translateX(0px)'
            })
          tl.play()
        }
      }
    },
    enter: function () {
      var tl = new TimelineLite({
        paused: true
      })
      if (this.$route.name === 'home') {
        tl.to([this.$refs.view.$refs.object1, this.$refs.view.$refs.object2, this.$refs.view.$refs.object3], 0, {
            opacity: 0,
            transform: 'translateY(20px)'
          })
          .to(this.$refs.view.$refs.object4, 0, {
            opacity: 0
          })
          .to(this.$refs.rectangle, 0, {
            transform: 'scaleX(0)',
            ease: Power1.easeIn
          })
      } else {
        tl.to([this.$refs.view.$refs.object1, this.$refs.view.$refs.object2, this.$refs.view.$refs.object3], 0, {
            opacity: 0,
            transform: 'translateY(20px)'
          })
          .to(this.$refs.view.$refs.object4, 0, {
            opacity: 0
          })
      }

      tl.play()
    },
    afterEnter: function () {
      var tl = new TimelineLite({
        paused: true
      })
      if (this.$route.name === 'home') {
        tl.to(this.$refs.view.$refs.object1, 0.4, {
            opacity: 1,
            transform: 'translateY(0px)'
          })
          .to(this.$refs.view.$refs.object2, 0.3, {
            opacity: 1,
            transform: 'translateY(0px)'
          }, 0.3)
          .to(this.$refs.view.$refs.object3, 0.3, {
            opacity: 1,
            transform: 'translateY(0px)'
          })
          .to(this.$refs.view.$refs.object4, 0.2, {
            opacity: 1
          }, 0.1)
          .to(this.$refs.rectangle, 0.5, {
            transform: 'scaleX(1)',
            ease: Power1.easeOut
          }, 0.1)
      } else {
        tl.to(this.$refs.view.$refs.object1, 0.4, {
            opacity: 1,
            transform: 'translateY(0px)'
          })
          .to(this.$refs.view.$refs.object2, 0.3, {
            opacity: 1,
            transform: 'translateY(0px)'
          }, 0.3)
          .to(this.$refs.view.$refs.object3, 0.3, {
            opacity: 1,
            transform: 'translateY(0px)'
          })
          .to(this.$refs.view.$refs.object4, 0.2, {
            opacity: 1
          }, 0.1)
      }
      tl.play()
      this.comp = this.$refs.view
    },
    leave: function () {
      var tl = new TimelineLite({
        paused: true
      })
      tl.to(this.$refs.rectangle, 0.4, {
          transform: 'scaleX(0)',
          ease: Power1.easeIn
        })
        .to(this.comp.$refs.object1, 0.4, {
          opacity: 0,
          transform: 'translateY(-20px)'
        })
        .to(this.comp.$refs.object2, 0.3, {
          opacity: 0,
          transform: 'translateY(-20px)'
        }, 0.2)
        .to(this.comp.$refs.object3, 0.3, {
          opacity: 0,
          transform: 'translateY(-20px)'
        }, 0.4)
        .to(this.comp.$refs.object4, 0.2, {
          opacity: 0
        }, 0.7)

      var tt = new TimelineLite({
        paused: true
      })
      tt.to(this.$refs.rectangle, 0.4, {
        transform: 'scaleX(0)',
        ease: Power1.easeIn
      })
      tt.play()
      tl.play()
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/app/app.js